import React from 'react';

const NotMatch = () => {
    return (
        <div style={{textAlign: 'center'}}>
            <h1>404</h1>
            <h3>OPPS! PAGE NOT FOUND</h3>
            <p>Sorry, the page you're looking for doesn't exist</p>
        </div>
    );
};

export default NotMatch;